import { z } from 'zod';

/////////////////////////////////////////
// MONIKER SCHEMA
/////////////////////////////////////////

export const MonikerSchema = z.object({
  monikerId: z.number().int(),
  cityId: z.number().int(),
  caseId: z.number().int(),
  moniker: z.string(),
})

export type Moniker = z.infer<typeof MonikerSchema>

export default MonikerSchema;
